<template>
    <div class="popup" :class="classObj">
        <van-popup :value="show" @click-overlay="close">
            <div class="content">
                <statusBar></statusBar>
                <div class="header">
                    <div>{{ $t("Setting.changePwd") }}</div>
                    <div class="close">
                        <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                    </div>
                </div>
                <div class="box">
                    <a-form-model ref="ruleForm" :model="form" :rules="rules" @submit.native.prevent>
                        <a-form-model-item label="" prop="oldPassword">
                            <a-input-password v-model="form.oldPassword" :placeholder="$t('Setting.oldPasswordTips')"
                                autocomplete="new-password" allowClear>
                                <i slot="prefix" class="iconfont icon-mima" />
                            </a-input-password>
                        </a-form-model-item>
                        <a-form-model-item label="" prop="newPassword">
                            <a-input-password v-model="form.newPassword" :placeholder="$t('Setting.passwordTips')"
                                autocomplete="new-password" allowClear>
                                <i slot="prefix" class="iconfont icon-mima" />
                            </a-input-password>
                        </a-form-model-item>
                        <a-form-model-item label="" prop="mathPassword">
                            <a-input-password v-model="form.mathPassword" :placeholder="$t('Setting.passwordTips2')"
                                autocomplete="new-password" allowClear>
                                <i slot="prefix" class="iconfont icon-mima" />
                            </a-input-password>
                        </a-form-model-item>
                    </a-form-model>
                    <a-button class="btn" @click="handleSubmit">{{ $t("Setting.changePwd") }}</a-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import statusBar from '@/components/statusBar'
import md5 from 'md5'
import { resetPwdBash64, logout } from '@/api/user'
import { Toast } from 'vant'

export default {
    name: 'changePwd',
    components: { statusBar },
    data() {
        const validatePass2 = (rule, value, callback) => {
            const reg = /^(?=.*[a-zA-Z])[a-zA-Z0-9\W_]{8,16}$/g
            if (!reg.test(value)) {
                callback(new Error(this.$t('login.PasswordFormat')))
            } else {
                callback()
            }
        }
        return {
            show: false,
            form: {
                oldPassword: '',
                newPassword: '',
                mathPassword: ''
            },
            rules: {
                oldPassword: [
                    { required: true, message: this.$t('Setting.PleaseEnterYourOriginalPassword'), trigger: 'blur' }
                ],
                newPassword: [
                    { required: true, message: this.$t('Setting.PleaseEnterYourNewPassword'), trigger: 'blur' },
                    { validator: validatePass2, trigger: 'blur' }
                ],
                mathPassword: [
                    { required: true, message: this.$t('Setting.PleaseEnterYourNewPasswordSure'), trigger: 'blur' }
                ]
            },
            debounceTimer: null
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        }
    },
    created() {
    },
    methods: {
        open() {
            this.show = true
        },
        close() {
            this.show = false
            this.form = {
                oldPassword: '',
                newPassword: '',
                mathPassword: ''
            }
            this.$refs.ruleForm.clearValidate()
        },
        handleSubmit() {
            const that = this
            clearTimeout(that.debounceTimer)
            that.debounceTimer = setTimeout(() => {
                that.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        const params = {
                            passwordOld: md5(that.form.oldPassword),
                            // password: md5(that.form.newPassword),
                            // passwordSure: md5(that.form.mathPassword)
                            password: btoa(that.form.newPassword),
                            passwordSure: btoa(that.form.mathPassword)
                        }
                        resetPwdBash64(params).then(res => {
                            if (!res) return
                            Toast(res.message)
                            if (res.code === 0) {
                                logout().then((res) => {
                                    if (res.code) return
                                    that.$websocket.close()
                                    that.close()
                                    that.$store.dispatch('user/setIsShowSettingPopup', false)
                                    that.$store.commit('user/SET_TOKEN', '')
                                    that.onPageRefresh()
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            }, 300)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    &.mobile {

        .van-popup {
            &.van-popup--center {
                width: 100% !important;
                height: 100% !important;
                max-width: 100% !important;
                min-height: 100% !important;
                max-height: 100% !important;
            }

            .content {
                width: 100% !important;
                // padding-bottom: .4rem;
                height: 100% !important;

                .header {
                    height: .94rem;
                    padding: 0 .28rem;

                    &>div:first-child {
                        font-size: .3rem;
                    }

                    .close {
                        font-size: .3rem;
                    }
                }
            }
        }
    }

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .content {
            background: $bg-popup-color;
            width: 500px;
            height: 700px;
            border-radius: .24rem;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            border: 1px solid rgba(205, 137, 61, .2);
            box-shadow: 0 .14rem .32rem rgba(35, 3, 4, .3);

            .header {
                display: flex;
                height: 76px;
                padding: 0 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: $bg-popup-navbar-color;

                &>div:first-child {
                    font-size: 20px;
                    font-weight: bold;
                    color: $font-color;
                }

                .close {
                    color: $font-component-muted-color;
                    font-size: 16px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s;

                    &:hover {
                        color: $font-color;
                        rotate: -180deg;
                    }
                }
            }

            .box {
                flex: 1;
                display: flex;
                flex-direction: column;
                position: relative;
                padding: 30px 40px;
                background: $bg-component-deep-color;

                ::v-deep .ant-form {
                    .ant-form-item {
                        margin-bottom: .43rem;

                        &.ant-form-item-with-help {
                            margin-bottom: 2.4px;
                        }

                        .language {
                            width: auto;
                            height: auto;
                            padding-right: .12rem;
                            border-right: .01rem solid $bg-popup-color;
                        }
                    }

                    .has-error {
                        .ant-input-prefix {
                            .iconfont {
                                position: relative;

                                &:after {
                                    content: '*';
                                    position: absolute;
                                    color: $font-component-hot-color;
                                    top: .02rem;
                                    right: -.1.5rem;
                                    font-size: .24rem;
                                }
                            }
                        }

                        .ant-form-explain {
                            height: .44rem;
                            line-height: .2rem;
                            font-size: 0.18rem;
                            padding: .02rem 0;
                            text-align: left;

                            &:not(.show-help-leave)::before {
                                background-color: $font-component-hot-color;
                                border-radius: 50%;
                                content: "";
                                height: 0.18rem;
                                margin-right: 0.1rem;
                                visibility: visible;
                                width: 0.18rem;
                                display: inline-block;
                                // background-image: url('@/assets/icons.png');
                                background-position: -13.509rem -4.59rem;
                                background-size: 13.689rem 13.419rem;
                            }
                        }
                    }
                }

                ::v-deep .ant-input-prefix {
                    left: .14rem;
                    color: $font-component-muted-color;

                    .icon-person,
                    .icon-mima {
                        font-size: .37rem;
                    }

                    .icon-mima {
                        font-size: .34rem;
                    }

                    .icon-open {
                        font-size: .2rem;
                    }

                    .icon-key-fill {
                        font-size: .34rem;
                    }

                    .icon-shebeizhuce {
                        font-size: .34rem;
                    }

                    .flag {
                        width: .28rem;
                        height: 0.22rem;
                        margin-right: .1rem;
                    }

                    span {
                        font-size: .23rem;
                        // margin-right: .1rem;
                        padding-right: .15rem;
                        color: $font-color;
                        border-right: .01rem solid $border-color;
                    }
                }

                ::v-deep .ant-input {
                    background-color: $bg-component-input-focus-color !important;
                    border-radius: 0.14rem;
                    font-size: 0.22rem;
                    height: 0.85rem;
                    padding: 0px 0.65rem !important;
                    color: $font-component-light-color;
                    border: .02rem solid $border-component-input-focus-color !important;

                    &:focus {
                        background-color: transparent;
                        border-color: $border-active-color !important;
                    }

                    &::-webkit-input-placeholder {
                        /* WebKit browsers */
                        font-size: .22rem;
                        color: $font-component-muted-color;
                        opacity: .7;
                        font-weight: 100;
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        font-size: .22rem;
                        color: $border-component-deep-color;
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        font-size: .22rem;
                        color: $border-component-deep-color;
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10+ */
                        font-size: .22rem;
                        color: $border-component-deep-color;
                    }
                }

                ::v-deep .ant-input-suffix {
                    .ant-input-clear-icon {
                        color: $font-component-field-color;
                        font-size: .32rem;
                    }
                }

                .ant-input-affix-wrapper {
                    &.ant-input-password {
                        ::v-deep .ant-input {
                            padding-right: 1rem;
                        }

                        ::v-deep .ant-input-suffix {
                            .ant-input-password-icon {
                                margin-right: .1rem;
                                font-size: .3rem;
                                color: $font-component-muted-color;
                            }
                        }
                    }
                }

                .btn {
                    width: 100%;
                    font-size: .24rem;
                    height: .72rem;
                    text-align: center;
                    line-height: .72rem;
                    background: $bg-btn-color;
                    color: $font-btn-color;
                    font-weight: bold;
                    border-radius: .18rem;
                    margin: .22rem 0;
                    cursor: pointer;
                    box-shadow: inset 0 1px 0 rgba(255, 248, 214, .6), 0 .06rem .14rem rgba(77, 20, 4, .2);

                    &.ant-btn {
                        border-color: rgba(214, 173, 84, .5);
                    }
                }
            }
        }
    }
}

.van-popup {
    .content {
        .header .close {
            color: $font-theme-color;
        }

        .header {
            border-bottom: 1px solid rgba(205, 137, 61, .18);

            > div:first-child {
                color: $font-color;
            }
        }

        .box {
            ::v-deep .ant-input-prefix {
                color: $font-component-warning-soft-color;
            }

            ::v-deep .ant-input {
                background: rgba(92, 6, 10, .62) !important;
                color: $font-color;
                border-color: rgba(205, 137, 61, .36) !important;
                box-shadow: inset 0 1px 0 rgba(255, 228, 186, .05);

                &::-webkit-input-placeholder {
                    color: $font-theme-color;
                }
            }

            ::v-deep .ant-form-item-explain,
            ::v-deep .ant-form-explain {
                color: #ffb39a;
            }

            .ant-input-affix-wrapper.ant-input-password ::v-deep .ant-input-suffix .ant-input-password-icon {
                color: $font-component-warning-soft-color;
            }

            .btn {
                background: $bg-component-pink-button-color;
                color: $border-component-deep-color;
            }
        }
    }
}

.popup {
    .van-popup {
        .content {
            background: $bg-component-panel-soft-color !important;
            border: 1px solid rgba($border-active-color, .22) !important;
            box-shadow: $shadow-component-panel-color !important;

            .header {
                background: $bg-component-blue-deep-gradient-color !important;
                border-bottom: 1px solid rgba($font-title-color, .16) !important;

                >div:first-child,
                .close {
                    color: $font-component-cool-color !important;
                }
            }

            .box {
                background: $bg-component-deep-color !important;

                ::v-deep .ant-input-prefix {
                    color: $font-component-info-color !important;
                }

                ::v-deep .ant-input {
                    background: rgba($bg-component-input-focus-color, .92) !important;
                    color: $font-component-cool-color !important;
                    border-color: rgba($border-active-color, .26) !important;
                    box-shadow: inset 0 1px 0 rgba($font-title-color, .05) !important;

                    &::-webkit-input-placeholder {
                        color: $font-component-info-soft-color !important;
                    }
                }

                ::v-deep .ant-form-item-explain,
                ::v-deep .ant-form-explain {
                    color: $font-component-info-strong-color !important;
                }

                .ant-input-affix-wrapper.ant-input-password ::v-deep .ant-input-suffix .ant-input-password-icon {
                    color: $font-component-info-strong-color !important;
                }

                .btn {
                    background:
                        linear-gradient(180deg, rgba($font-title-color, .18) 0%, rgba($font-title-color, .05) .12rem, rgba($font-title-color, 0) .13rem),
                        $bg-component-highlight-color !important;
                    color: $font-color !important;
                    border-color: rgba($border-active-color, .24) !important;
                    box-shadow: 0 .12rem .24rem rgba($bg-shell-color, .22), 0 0 .22rem rgba($border-active-color, .14) !important;
                }
            }
        }
    }
}
</style>
